import script from "./HomeNew.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeNew.vue?vue&type=script&setup=true&lang=js"

import "./HomeNew.vue?vue&type=style&index=0&id=5c111610&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c111610"]])

export default __exports__